<template>
  <el-dialog
    title="グループ作成"
    :visible.sync="isOpenCreateModal"
    width="50%"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :before-close="onCloseModal"
  >
    <el-form
      ref="creationForm"
      :model="organization"
      label-width="30%"
      :rules="rules"
      @submit.prevent.native="onSubmit"
    >
      <div>
        <ErrorMessage :messages="errorMessages" @close="errorMessages = null" />
      </div>
      <el-form-item label="アカウント名" prop="name">
        <el-input name="name" v-model="organization.name"></el-input>
      </el-form-item>
      <el-form-item label="アカウントID" prop="contact_email">
        <el-input
          name="contact_email"
          type="text"
          v-model="organization.contact_email"
        ></el-input>
      </el-form-item>

      <el-form-item label="有効期限" prop="expired_at">
        <el-date-picker
          v-model="organization.expired_at"
          type="date"
          placeholder="Pick a day"
          style="width: 100%;"
          :picker-options="datePickerOptions"
          value-format="yyyy-MM-dd"
          v-on="$listeners"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="アカウント個数制限" prop="max_user_account">
        <el-input-number
          name="max_user_account"
          class="max-user-account"
          type="text"
          :max="99"
          :min="1"
          v-model="organization.max_user_account"
        />
      </el-form-item>
      <el-form-item label="機能権限" prop="engine_ids">
        <el-checkbox-group name="path" v-model="organization.engine_ids">
            <el-checkbox v-for="item in patchCard" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="パスワード" prop="password">
        <el-input
          name="password"
          type="password"
          v-model="organization.password"
        ></el-input>
      </el-form-item>
      <div class="text-right">
        <el-button @click="onCloseModal">キャンセル</el-button>
        <el-button native-type="submit" class="btn-main" :disabled="isLoading">
          <i v-if="isLoading" class="el-icon-loading"></i>
          保存
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { types } from "@/constants/organization";
// import { validEmail } from "@/utils/validate";
import { mapActions } from "vuex";
import EngineApi from "@/api/engine.api";
import ErrorMessage from "@/components/ErrorMessage";
import moment from "moment/moment";

export default {
  name: "CreateOrganization",
  components: { ErrorMessage },
  data() {
    return {
      organization: {
        name: '',
        contact_email: '',
        expired_at: '',
        max_user_account: undefined,
        password: '',
        engine_ids: [],
        type: 1
      },
      datePickerOptions: {
        disabledDate(date) {
          return date < moment().subtract(1, 'days')
        }
      },
      patchCard: [],
      rules: {
        name: [
          { required: true, trigger: "blur", message: 'アカウント名を入力してください' },
          { max: 100, trigger: "blur", message: '100 文字以下にしてください。' },
        ],
        expired_at: [
          { required: true, trigger: 'blur' , message: '有効期限を入力してください' }
        ],
        max_user_account: [
          { required: true,type: "number", trigger: 'blur', message: 'アカウント個数制限を入力してください' },
          // { max: 999999, trigger: 'blur', message: '6 文字以下にしてください。' },
        ],
        engine_ids: [
          { type: 'array', required: true, trigger: 'blur', message: '機能権限を入力してください' }
        ],
        password: [
          { required: true, trigger: 'blur', message: 'パスワードを入力してください' },
          { min: 8, max: 20, trigger: 'blur', message: 'パスワードは８文字以上、２０文字以内で入力してください。' }
        ],
        contact_email: [
          {required: true, trigger: 'blur', message: 'アカウントIDを入力してください',},
          // {
          //   validator: (rule, value, callback) => {
          //     if (!validEmail(value)) {
          //       callback(new Error('有効なメールアドレスを入力してください。'));
          //     } else {
          //       callback();
          //     }
          //   },
          //   trigger: 'blur'
          // },
          { max: 100, trigger: "blur", message: '100 文字以下にしてください。' },
        ],
      },
      isLoading: false,
      errorMessages: null,
    };
  },
  props: {
    isOpenCreateModal: {
      default: false,
    },
  },

  computed: {
    typeList() {
      return types;
    },
  },

  methods: {
    ...mapActions("admin_organizations", ["create"]),

    handleNumber(event) {
      if (this.inputValue !== null && this.inputValue instanceof String) {
        this.inputValue = this.inputValue.toString().replace(/[^\d].+/, '')
      }
      if ((event.which < 48 || event.which > 57)) {
        event.preventDefault()
      }
    },

    async getListEngine() {
      await EngineApi.getEngineList().then((res) => {
        this.patchCard = res.data
      })
    },

    onCloseModal() {
      this.$emit("close");
      this.$refs.creationForm.resetFields()
      return true;
    },

    initData() {
      this.errorMessages = null;
      this.getListEngine()
    },

    async onSubmit() {
      if (this.isLoading) return false;
      this.errorMessages = null;
      this.$refs.creationForm.validate(async (isValid) => {
        if (!isValid) return false;
        this.isLoading = true;
        let res = await this.create({...this.organization, amount_limit: this.organization.max_user_account});
        this.isLoading = false;
        if (!res.success) {
          if (res.data) this.errorMessages = res.data;
          return false;
        }
        this.$emit("onOrganizationCreated");
        this.$refs.creationForm.resetFields();
      });
    },
  },

  watch: {
    isOpenCreateModal(newVal, oldVal) {
      if (newVal && newVal !== oldVal) this.initData();
    },
  },
};
</script>
<style scoped>
/deep/.max-user-account .el-input > .el-input__inner {
    padding-left: 15px;
    padding-right: 15px;
    text-align: left;
}
/deep/.max-user-account {
    width: 100%;
}
/deep/.max-user-account > .el-input-number__decrease, /deep/.max-user-account > .el-input-number__increase {
    display: none !important;
}
</style>
